import { on, unByKey } from 'cadenza/utils/event-util';
import { CONDITION_CHANGE } from 'cadenza/conditions/event-types';

const NAME = 'd-condition-wrapper';

export class ConditionWrapper extends HTMLElement {

  #initiallyFocused;

  constructor (focused) {
    super();
    this.#initiallyFocused = focused;
  }

  connectedCallback () {
    this.classList.add(NAME, 'condition-wrapper');
    setTimeout(() => { // Light DOM is ready
      this._condition = this.querySelector('.condition');
      this._resetBtn = this.querySelector('.d-condition--reset');
      this.updateResetBtnVisibility();
      if (this.#initiallyFocused) {
        this._condition.focus();
      }
      this._eventKeys = [
        on(this._resetBtn, 'click', () => this._onResetCondition()),
        on(this, CONDITION_CHANGE, () => this._onConditionChange())
      ];
    });
  }

  disconnectedCallback () {
    unByKey(this._eventKeys);
  }

  _onResetCondition () {
    this._condition.focus();
    this.resetCondition();
  }

  _onConditionChange () {
    this.updateResetBtnVisibility();
  }

  resetCondition (triggerConditionChange = true) {
    if (this._condition) { // if condition already rendered
      this._condition.reset(triggerConditionChange);
      this._resetBtn.hidden = true;
    }
  }

  updateResetBtnVisibility () {
    this._resetBtn.hidden = !this._condition.changed;
  }

}

customElements.define(NAME, ConditionWrapper);
